// extracted by mini-css-extract-plugin
export default {"TariffTypeBlock":"TariffTypeBlock_TariffTypeBlock__tRUUv","info":"TariffTypeBlock_info__1Gr+l","link":"TariffTypeBlock_link__9gg+H"};